export default {
	// baseUrl:"http://media.test/media"
	// baseUrl: "http://media.local:8080/"
	// baseUrl: "https://6bf64f27.ngrok.io/"
	baseUrl: "https://img.games.clap.co.il"
};
